import LinkedinProductClassicIcon from './hosted-auth/products-icons/linkedin.png';
import LinkedinProductCompanyIcon from './hosted-auth/products-icons/pages.png';
import LinkedinProductRecruiterIcon from './hosted-auth/products-icons/recruiter.png';
import LinkedinProductSalesNavigatorIcon from './hosted-auth/products-icons/sales_navigator.png';

export const linkedinProducts = ['classic', 'company', 'recruiter', 'sales_navigator'] as const;
export type LinkedinProduct = (typeof linkedinProducts)[number];

export const linkedinProductIcons: Record<LinkedinProduct, string> = {
  classic: LinkedinProductClassicIcon,
  company: LinkedinProductCompanyIcon,
  recruiter: LinkedinProductRecruiterIcon,
  sales_navigator: LinkedinProductSalesNavigatorIcon,
};

export const linkedinProductLabels: Record<LinkedinProduct, string> = {
  classic: 'Personal',
  company: 'Company Pages',
  recruiter: 'Recruiter',
  sales_navigator: 'Sales Navigator',
};

export const isLinkedinProduct = (value: unknown): value is LinkedinProduct => {
  return typeof value === 'string' && value in linkedinProductLabels;
};
